module.exports = __webpack_public_path__ + "static/media/image-4.063f9e7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-nuevo/image-4.jpg
// module id = 257
// module chunks = 0